import { CircularSpinner } from '@festina-life/ui/feedback'
import { useTranslateEnum } from '@festina-life/ui/hooks'
import { Suspense } from 'react'

import { Category } from './Category'
import { Group } from './Group'
import type { RankedItem, RenderedCategory, SearchableItemGroup } from './types'

type Props = {
  group: SearchableItemGroup
  categoryAndItems: {
    category: RenderedCategory
    items: RankedItem[] | undefined
  }[]
}

export const CategoryGroup = ({ group, categoryAndItems }: Props) => {
  const translateEnum = useTranslateEnum()

  return (
    <Group
      key={group}
      group={group}
      groupName={translateEnum('enum.SearchGroup', group)}
    >
      <Suspense fallback={<CircularSpinner className="m-2 size-8" />}>
        {categoryAndItems.map(({ category, items }) => (
          <Category
            key={category.label}
            category={category}
            items={items ?? []}
            group={group}
          />
        ))}
      </Suspense>
    </Group>
  )
}
